import { render, staticRenderFns } from "./userMainLayout.vue?vue&type=template&id=652e6772"
import script from "./userMainLayout.vue?vue&type=script&lang=js"
export * from "./userMainLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports